import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import 'flatpickr/dist/themes/airbnb.css';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js';
import 'flatpickr/dist/plugins/monthSelect/style.css';

window.flatpickr = flatpickr;
window.flatpickrPlugins = { monthSelect: monthSelectPlugin };

const $ = window.$;

// TODO: centralize flatpickr defaults — Sprockets-compiled pickers (orders_index.coffee, working_hours_csv_form.coffee) duplicate these manually
const defaults = {
  time_24hr: true,
  locale: { firstDayOfWeek: 1 },
  static: true,
  onDayCreate(_selectedDates, _dateStr, _flatpickrInstance, dayElem) {
    const day = dayElem.dateObj.getDay(); // 0 = niedziela, 6 = sobota
    if (day === 0 || day === 6) {
      dayElem.classList.add('flatpickr-weekend');
    }
  },
};

function initFlatpickr(el, options = {}) {
  options = { ...defaults, ...options };
  if (el._flatpickr) return el._flatpickr;

  el.setAttribute('autocomplete', 'off');
  const instance = flatpickr(el, {
    ...options,
    onChange(selectedDates, dateStr, inst) {
      const oldDate = el._fp_prev_date || null;
      $(el).trigger('flatpickr:change', [selectedDates[0] || null, oldDate, dateStr]);
      el._fp_prev_date = selectedDates[0] ? new Date(selectedDates[0]) : null;
      if (options.onChange) options.onChange(selectedDates, dateStr, inst);
    },
  });

  el._fp_prev_date = instance.selectedDates[0] ? new Date(instance.selectedDates[0]) : null;
  return instance;
}

window.initFlatpickr = initFlatpickr;

function positionCalendarFixed(instance) {
  const cal = instance.calendarContainer;
  const rect = instance.input.getBoundingClientRect();
  const calWidth = cal.offsetWidth || 300;
  let left = rect.left;
  if (left + calWidth > window.innerWidth) left = Math.max(0, window.innerWidth - calWidth - 4);
  cal.style.position = 'fixed';
  cal.style.top = `${rect.bottom + 2}px`;
  cal.style.left = `${left}px`;
  cal.style.right = 'auto';
}

function monthsAgo(count) {
  const date = new Date();
  date.setMonth(date.getMonth() - count);
  return date;
}

function addRangeShortcuts(el, instance) {
  const presets = [
    ['lastMonth', el.dataset.presetLastMonth, 1],
    ['lastSixMonths', el.dataset.presetLastSixMonths, 6],
    ['lastYear', el.dataset.presetLastYear, 12],
  ];
  if (!presets.some(([, label]) => label)) return;

  const container = document.createElement('div');
  container.className = 'flatpickr-shortcuts';
  presets.forEach(([, label, months]) => {
    if (!label) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'button button--white flatpickr-shortcuts__button';
    button.textContent = label;
    button.addEventListener('click', () => {
      instance.setDate([monthsAgo(months), new Date()], true);
      instance.close();
    });
    container.appendChild(button);
  });
  instance.calendarContainer.appendChild(container);
}

$(function () {
  $('.datepicker, .datepicker--time, .datepicker--range').attr('autocomplete', 'off');
});

// Bootstrap 3's enforceFocus traps focus inside modals, which fights flatpickr's
// own focus management and causes infinite recursion. Patch it to allow flatpickr.
$(document).on('focusin.modal', (e) => {
  if ($(e.target).closest('.flatpickr-calendar').length) {
    e.stopImmediatePropagation();
  }
});

$(document)
  .on('focus', '.datepicker:not(.flatpickr-input)', function () {
    // flatpickr's default (inline, positioned against the nearest
    // positioned ancestor) gets clipped by overflow:hidden ancestors, and
    // a <dialog> renders in the browser's top layer so anything appended
    // to document.body would sit behind it regardless of z-index.
    // TL;DR: always escape to a fixed position, appended to the nearest
    // dialog (or body if none), never flatpickr's inline default.
    const dialog = this.closest('dialog');
    const options = {
      dateFormat: 'Y-m-d',
      allowInput: true,
      static: false,
      appendTo: dialog || document.body,
      position: positionCalendarFixed,
    };

    initFlatpickr(this, options).open();
  })  
  .on('focus', '.datepicker--range:not(.flatpickr-input)', function () {
    const el = this
    const gteqSel = el.dataset.gteqTarget
    const lteqSel = el.dataset.lteqTarget
    const options = {
      dateFormat: 'Y-m-d',
      allowInput: true,
      mode: 'range',
      locale: { ...defaults.locale, rangeSeparator: ' - ' },
      static: false,
      position: positionCalendarFixed,
      onOpen(_, __, instance) {
        window.addEventListener('scroll', () => instance.close(), { once: true, passive: true })
      },
      onReady(_, __, instance) {
        addRangeShortcuts(el, instance)
      },
    }
    if (gteqSel || lteqSel) {
      const fmt = d => flatpickr.formatDate(d, 'Y-m-d')
      const gteqEl = () => gteqSel ? document.querySelector(gteqSel) : null
      const lteqEl = () => lteqSel ? document.querySelector(lteqSel) : null
      const triggerSubmit = () => {
        const el = gteqEl()
        if (el) el.dispatchEvent(new Event('change', { bubbles: true }))
      }
      options.onChange = function (selectedDates) {
        const ge = gteqEl(); const le = lteqEl()
        if (ge) ge.value = selectedDates[0] ? fmt(selectedDates[0]) : ''
        if (le) le.value = selectedDates[1] ? fmt(selectedDates[1]) : ''
        // Don't submit mid-selection (only one date chosen); submit when complete or cleared
        if (selectedDates.length !== 1) triggerSubmit()
      }
      // Single date selected and calendar closed: treat as exact-date filter
      options.onClose = function (selectedDates) {
        if (selectedDates.length !== 1) return
        const dateStr = fmt(selectedDates[0])
        const ge = gteqEl(); const le = lteqEl()
        if (ge) ge.value = dateStr
        if (le) le.value = dateStr
        triggerSubmit()
      }
    }
    initFlatpickr(el, options).open()
  })
  .on('focus', '.datepicker--time:not(.flatpickr-input)', function () {
    const instance = initFlatpickr(this, { dateFormat: 'Y-m-d H:i', enableTime: true });
    setTimeout(() => instance.open(), 0);
  });
